module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av729-af494a5ad8346faa1ce536a3cf0193c2.jpg";